import { render, staticRenderFns } from "./RuleModal.vue?vue&type=template&id=d084e650&scoped=true&"
import script from "./RuleModal.vue?vue&type=script&lang=ts&"
export * from "./RuleModal.vue?vue&type=script&lang=ts&"
import style0 from "./RuleModal.vue?vue&type=style&index=0&id=d084e650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d084e650",
  null
  
)

export default component.exports